export default "__VITE_ASSET__CBZxGQr4__"